import React from 'react';
import { Layout } from 'antd';
import { CompareWrapper } from '@components/compare-panel';

const CustomDashboard = ({ match, isSharing }) => {
  const queryId = match.params.id;

  return (
    <>
      {/* <SummaryContainer /> */}
      <Layout.Content className="container">
        <CompareWrapper
          isSharing={isSharing}
          match={match}
          id={queryId}
        />
      </Layout.Content>
    </>
  );
};

CustomDashboard.defaultProps = {
  match: {},
  isSharing: false,
};

export default CustomDashboard;
